var songkickids = ['301793', '8730654', '2395373', '4406688', '8434308', '7198399', '7026114', '8551764', '287169', '9563889', '8701388', '10191721', '67651', '126518', '6393489', '2552601', '4126311', '748466', '14184', '280467', '927362', '3054296', '144136', '332148', '132778', '9039634', '8485788', '10161992', '2113830', '9061784', '1894102', '8916364', '10196692', '489976', '8062413', '60311', '9546119', '6232909', '2746696', '130918', '416990', '10125053', '608150', '10304330'];
var performanceArtists = []

async.each(songkickids, function (songkickid, done) {
  var artistid = songkickid;
  var url = 'https://api.songkick.com/api/3.0/artists/' + artistid + '/calendar/tourbox.json?apikey=ZJnUmPABi49Zbg28&jsoncallback=?';

  // Get artist data
  $.getJSON(url, function (data) {
    var total_entries = data.resultsPage.totalEntries

    if (total_entries > 0) {
      var performances = data.resultsPage.results.performance;

      // console.log(performances)
      
      var artist_name = performances[0].artist.displayName

      performanceArtists.push({ id: artistid, name: artist_name,  performances: performances })
    }

    done()
  })
}, function () {
  // Sort artists alphabetically after iterating entire array
  var sortedPerformanceArtists = performanceArtists.sort(function(a, b) {
    return a.name.localeCompare(b.name)
  })

  // Display artists
  displayPerformances(sortedPerformanceArtists)

  var $tourFilter = $('#tours-filter')  
  if ($tourFilter.length) {
    var $tourFilterSelect = $tourFilter.find('select')
    var $tourFilterSearch = $tourFilter.find('input')

    // Populate artist filter select
    sortedPerformanceArtists.forEach(function (artist) {
      $tourFilterSelect.append('<option value="' + artist.id + '">'  + artist.name + '</option>')
    })

    // Filter items when option is selected
    $tourFilterSelect.change(function (e) {
      var artistId = $(e.target).val()

      $('#tours-wrapper > div').show()

      if (artistId) {
        var filter = $('#tours-wrapper > div').not('#tour_' + artistId)
        filter.hide()
      }  
    })

    $tourFilterSearch.on('input', function (e) {
      var query = $(e.target).val();
      
      // code change by mlveda
      $('#tours-wrapper').empty()

      if (!query) {
        return displayPerformances(sortedPerformanceArtists)
      }

      var matches = []
      sortedPerformanceArtists.forEach(function (artist) {
        var performances = artist.performances.filter(function(performance) {
          return performance.event.location.city.toLowerCase().includes(query.toLowerCase())
        })

        if (performances.length) {
          matches.push(Object.assign({}, artist, { performances: performances }))          
        }
      })


      // $('#tours-wrapper').empty()
      displayPerformances(matches)
    })
  }
})

function displayPerformances (artists) {
  artists.forEach(function (artist) {
    // What's the artists name? We can grab it from the first result.
    var artist_name = artist.name

    //console.log(artist_name);

    // Edit: set the artist's id in a separate variable for compatibility
    var artistid = artist.id
    

    $("#tours-wrapper").append('<div id="tour_' + artistid + '" class="tour-card"><h4 class="artist-name">' + artist_name + '</h4><div class="feature_divider"></div><ul id="tours_' + artistid + '" class="performances tours-grid"></ul></div>');


    // Now we loop through all the performances for this artist

    artist.performances.forEach(function (item, index, array) {

      //console.log(array[index]);
      var with_bands = '';

      if (typeof array[index].event.performance !== 'undefined' && array[index].event.type != 'Festival') {

        with_bands = with_bands + '<span class="supporting">w/ ';

        var performance_bands = array[index].event.performance;

        performance_bands.forEach(function (band_item, band_index, band_array) {

          if (performance_bands[band_index].displayName != artist_name) {

            with_bands = with_bands + performance_bands[band_index].displayName + ', ';
          }


        });
      }

      if (array[index].date == null) {
        var performance_date = array[index].event.start.date;
      } else {

        var performance_date = array[index].date;
      }

      var date = Date.parse(performance_date).toString('ddd, MMM dd');

      if (typeof array[index].event.end !== 'undefined' && array[index].event.type == 'Festival' && array[index].date == null) {

        var end_date = Date.parse(array[index].event.end.date).toString('ddd, MMM dd');
        if (end_date != date) {
          date = date + ' - ' + end_date;
        }

      }

      if (array[index].event.type != 'Festival' && array[index].event.type != 'LiveStreamConcert') {
        var performance_venue = array[index].event.venue.displayName;
      } else {
        if (array[index].event.type == 'LiveStreamConcert') {
          var performance_venue = 'Livestream';
        
        }else{
          var performance_venue = array[index].event.displayName + '<br>' + array[index].event.venue.displayName;
        }
        
          
      }
	  if (array[index].event.type == 'LiveStreamConcert') {
         var performance_city = 'Online';
      }else{
         var performance_city = array[index].event.location.city;
      }
      
      var performance_link = array[index].event.uri;
      var performance_status = array[index].event.status;
      
 
      var performance_details = ' <a href="' + performance_link + '" target="_blank">Tickets</a>';

      if (performance_venue == 'Unknown venue') {
        var venue = array[index].event.displayName;
      } else {
        var venue = performance_venue;
      }

      if (with_bands != '<span class="supporting">w/ ' && with_bands !== 'undefined') {

        venue = venue + '<br>' + with_bands;
        venue = venue.replace(/,\s*$/, "") + '</span>';
      }


      if(performance_status == 'cancelled' || performance_status == 'postponed'){
        $('#tours_' + artistid).append('<li class="tour_artist"><div class="tour_event clearfix"><div class="three columns tour_date alpha">' + date + '<div class="status-label"><span>'+ performance_status +'</span></div></div><div class="five columns tour_venue">' + venue + '</div><div class="five columns tour_city">' + performance_city + '</div><div class="three columns omega tour_link">' + performance_details + '</div></div></li>');
        
      }else{
        $('#tours_' + artistid).append('<li class="tour_artist"><div class="tour_event clearfix"><div class="three columns tour_date alpha">' + date + '</div><div class="five columns tour_venue">' + venue + '</div><div class="five columns tour_city">' + performance_city + '</div><div class="three columns omega tour_link">' + performance_details + '</div></div></li>');
    
      }
    });
  })
}